import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import Dashboard from "../../../components/lotto12v2/mobile/Dashboard";
import {lotto12DrawStyle} from "../../../constants/general";
import MainDrawingWrapper from "../../../components/lotto12v2/MainDrawingWrapper";

class Index extends Component {
    render() {
        return (
            <MainDrawingWrapper drawStyle={lotto12DrawStyle.circle} {...this.props}>
                <Dashboard />
            </MainDrawingWrapper>
        );
    }
}


export default withTranslation()(Index)
